import { render, staticRenderFns } from "./KnInventoryMovements.vue?vue&type=template&id=d6fd32d2&"
import script from "./KnInventoryMovements.vue?vue&type=script&lang=js&"
export * from "./KnInventoryMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports